__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/3b2bb6f/_next/";